enum DriverEditAddressType {
  MAILING = "MAILING",
  STARTING = "STARTING",
}

export default DriverEditAddressType;
